class OffsetHeight {

    /**
     * @since 4.7.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector  = '[data-offset-height]';
        this.initClass = 'offset-initialized';

        // Run initialization
        this.init();

        // Run again if called elsewhere
        $(document).on('ll5RunOffsetHeight', () => this.init());

        // Run again when the page resizes
        $(window).on('resize', () => this.init(true));
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.18.0
     * @param bool reInit is a flag indicating we want to rerun run-once things
     * @returns object The initialized map
     */
    init(reInit) {
        // If there are no countdowns, bail
        if (!$(this.selector).length)
            return;

        // Declare and initialize
        var initClass      = this.initClass;
        var accessoryClass = 'offset-height-accessory-processed';

        // Add classes to each of them
        $(this.selector).each(function () {

            // Undo any previous heights
            if ($(this).hasClass(initClass))
                $(this).css('height', '').removeClass(initClass);

            // Declare and initialize
            let ele            = $(this)[0];
            let target         = $(this).data('offset-height-target');
            let setHeight      = $(this).data('offset-height-set');
            let minEle         = $(this).find('[data-offset-height-min]');
            let minHeight      = !!minEle.length ? minEle.outerHeight() : 0;
            let exclude        = ':not([data-offset-height-ignore="on"])';
            let targets        = !target ? $(this).prevAll(exclude) : $(target);
            let height         = $(this).height();
            let viewportHeight = document.documentElement.clientHeight;
            let targetHeight   = 0;
            let viewHeight     = setHeight || 0;

            // If there is no target(s), assume previous siblings
            if (!targets.length)
                return;

            // Calculate a view height if one was not set
            if (!setHeight) {

                // Calculate a cheeky view height value
                let minHeight = Math.min(viewportHeight, height);
                let maxHeight = Math.max(viewportHeight, height);

                // Calculate the view height based on 100 screen coverage
                viewHeight = (minHeight / maxHeight) * 100;

            }

            // Run through the targets
            targets.each((i, e) => {

                // Compound our target height
                targetHeight += $(e).height();

            });

            // Add in the admin bar height (just in case)
            if ($('body').hasClass('admin-bar'))
                targetHeight += $('#wpadminbar').height();

            // Account for rounding errors
            targetHeight -= 1;

            // Set our new height
            $(this).css(
                'height',
                'calc(' + viewHeight + 'vh - ' + targetHeight + 'px)'
            );

            // Set minimum height if we have it
            if (0 < minHeight)
                $(this).css('min-height', minHeight);

            // Handle the accessories
            $(this).find('[data-offset-height-accessory]').each(function (e) {

                // Ignore initialized elements when not re-initializing
                if (!reInit && $(this).hasClass(accessoryClass))
                    return;

                // Revert height
                $(this).removeAttr('style');

                // Give a little leeway
                let spacer = '5px';

                // Offset the height
                $(this)
                    .addClass(accessoryClass)
                    .css({
                        'height':       'calc(100% + ' + (targetHeight * 2) + 'px + ' + spacer + ')',
                        'marginTop':    '-' + targetHeight + 'px',
                        'marginBottom': 0
                    });

            });

            // Add in our initialized class
            $(this).addClass(initClass);

        });

        // Prevent leaks
        return;
    }

}

export default OffsetHeight;